import React, { useContext } from 'react';
import { FormInstance } from 'antd/lib/form/Form';
import { Row } from 'antd';
import DF from 'DisplayFramework';
import { ParMarketingResponse } from 'services/assetconfig';
import FormInput from 'components/FormInput';
import AssetUpload from 'components/AssetUpload';
import { AuthContext } from 'components/Auth/Auth';
import Button from 'components/Button';

type MarketingLabelDetailProps = {
  mc?: ParMarketingResponse;
  mainForm: FormInstance;
  // OnCancel?: () => void;
  onSuccess: () => void;
  onValidatePicture?: (url: string) => void;
};

const MarketingPictures = ({
  mainForm: form,
  // OnCancel,
  onSuccess,
  onValidatePicture,
}: MarketingLabelDetailProps) => {
  const { isInspect } = useContext(AuthContext);
  return (
    <DF.Provider pagcode="marketinglabeldetail">
      <div className="card-container">
        <Row justify="end">
          <Button
            htmlType="button"
            size="middle"
            comcode="validate"
            onClick={() => {
              !isInspect && onSuccess();
              onValidatePicture &&
                onValidatePicture(form.getFieldValue('pictureurl'));

              form.setFieldsValue({
                pictureurl: form.getFieldValue('pictureurl'),
              });
            }}
            style={{ width: '115px', height: '38px' }}
          />
          {/* <ButtonOperation
            size="large"
            comcode="validate"
            icon={<ISave color="white" />}
            type="primary"
            style={{ float: 'right', height: '20px' }}
            onClick={() => {
              onSuccess();
            }}
          /> */}
        </Row>
        <Row gutter={18}>&nbsp;</Row>
        <Row>
          <FormInput
            col
            lg={8}
            onlylabel="picturebuttomlefturl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="picturebuttomlefturl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>

          <FormInput
            col
            lg={8}
            onlylabel="picturebuttomrighturl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="picturebuttomrighturl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>

          <FormInput
            col
            lg={8}
            onlylabel="picturecenterurl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="picturecenterurl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>

          <FormInput
            col
            lg={8}
            onlylabel="picturemobileurl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="picturemobileurl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>

          <FormInput
            col
            lg={8}
            onlylabel="picturetoplefturl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="picturetoplefturl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>

          <FormInput
            col
            lg={8}
            onlylabel="picturetoprighturl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="picturetoprighturl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>

          <FormInput
            col
            lg={8}
            onlylabel="pictureurl"
            labelCol={{ span: '2px' }}
          >
            <AssetUpload
              simpleUpload
              form={form}
              name="pictureurl"
              objectreference={form.getFieldValue('assetreference')}
            />
          </FormInput>
        </Row>
      </div>
    </DF.Provider>
  );
};

export default MarketingPictures;
